const initialState = {
  resultsList: [],
};

export const PlatformResultsReviewReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "platformResultsReview")
    return action.execute(state);
  return state;
};
